import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RatingContainer } from "./Rating.styles";
import { RatingStar, RatingStarAppearance } from "./RatingStar";
var Rating = function(param) {
    var value = param.value, _maxStars = param.maxStars, maxStars = _maxStars === void 0 ? 5 : _maxStars, starSize = param.starSize;
    if (!value) {
        return null;
    }
    var stars = new Array(maxStars).fill(null).map(function(_, index) {
        return index + 1;
    });
    var halfStarsValue = Math.round(value * 2);
    return /*#__PURE__*/ _jsx(RatingContainer, {
        role: "img",
        "aria-label": "Rating: ".concat(value, " out of ").concat(maxStars, " stars"),
        children: stars.map(function(i) {
            var appearance = RatingStarAppearance.Empty;
            if (halfStarsValue >= i * 2) {
                appearance = RatingStarAppearance.Full;
            } else if (halfStarsValue >= i * 2 - 1) {
                appearance = RatingStarAppearance.Half;
            }
            return /*#__PURE__*/ _jsx(RatingStar, {
                appearence: appearance,
                "aria-hidden": true,
                size: starSize
            }, i);
        })
    });
};
export { Rating };
